// extracted by mini-css-extract-plugin
module.exports = {"label--help":"HelpPopup_label--help__3wirk","label--help-icon-wrapper":"HelpPopup_label--help-icon-wrapper__qd7xz"};